module.exports = __webpack_public_path__ + "img/nmi-integration.5cac67c6.jpg";